const ERRORTOKEN = 'ERROR||'

exports.ERRORTOKEN = ERRORTOKEN
